import React from 'react';

type StatusType = 'active' | 'analysing' | 'stale' | 'draft' | 'failed' | 'queued';
type SentimentType = 'positive' | 'negative' | 'neutral' | 'mixed';
type EntityType = 'Brand' | 'Individual' | 'Organization';

interface StatusBadgeProps {
  type: 'status' | 'sentiment' | 'entity';
  value: StatusType | SentimentType | EntityType;
  size?: 'sm' | 'md';
}

const statusConfig: Record<string, { label: string; className: string }> = {
  active: { label: 'Active', className: 'status-active' },
  analysing: { label: 'Analysing', className: 'status-analysing' },
  stale: { label: 'Stale', className: 'status-stale' },
  draft: { label: 'Draft', className: 'status-draft' },
  failed: { label: 'Failed', className: 'risk-badge' },
  queued: { label: 'Queued', className: 'status-draft' },
};

const sentimentConfig: Record<string, { label: string; className: string }> = {
  positive: { label: 'Positive', className: 'sentiment-positive' },
  negative: { label: 'Negative', className: 'sentiment-negative' },
  neutral: { label: 'Neutral', className: 'sentiment-neutral' },
  mixed: { label: 'Mixed', className: 'bg-warning/10 text-warning border border-warning/30 rounded-full' },
};

const entityConfig: Record<string, { label: string; className: string }> = {
  Brand: { label: 'Brand', className: 'text-accent bg-accent/10 border border-accent/20' },
  Individual: { label: 'Individual', className: 'text-primary bg-primary/10 border border-primary/20' },
  Organization: { label: 'Organization', className: 'text-warning bg-warning/10 border border-warning/20' },
};

const FALLBACK = { label: '—', className: 'bg-muted text-muted-foreground border border-border' };

export default function StatusBadge({ type, value, size = 'sm' }: StatusBadgeProps) {
  const map = type === 'status' ? statusConfig : type === 'sentiment' ? sentimentConfig : entityConfig;
  const config = (value ? map[value] : undefined) ?? FALLBACK;

  const sizeClass = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-3 py-1';

  return (
    <span data-component-id="src/components/ui/StatusBadge.tsx:44:4" data-component-path="src/components/ui/StatusBadge.tsx" data-component-line="44" data-component-end-line="46" data-component-file="StatusBadge.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D" className={`inline-flex items-center rounded-full font-medium ${sizeClass} ${config.className}`}>
      {config.label}
    </span>
  );
}
